import React, { useCallback } from 'react'
import { useRouter } from 'next/router'
import { StyledItemContent } from './RankStyle'
import { MyImage } from '~/components/ui/MyImage'
import { FenToYuan } from '~/utils'
import CircleAndSquare from '~/components/icon/CircleAndSquare'
import { MyRare } from '~/components/ui/MyRare'
import {
  getArtWorksList_marketingModule_artworkSort_edges_node,
  RareFlag,
} from '~/graphqls/types'

export const WorksList: React.FC<{
  data: getArtWorksList_marketingModule_artworkSort_edges_node[]
  onChange?: (param: boolean) => void
}> = ({ data, onChange }) => {
  const router = useRouter()
  const type = router.asPath.split('/')?.[2]
  const handleLink = useCallback(id => {
    if (id) {
      router.push(`/product/${id}`)
    }
  }, [])
  return (
    <StyledItemContent>
      {data.map(
        (
          item: getArtWorksList_marketingModule_artworkSort_edges_node,
          index: number
        ) => (
          <div
            className="rank-list-item"
            key={`${item.sortId}_${index}`}
            onClick={() => handleLink(item?.artwork?.id)}
          >
            <div className="left">
              <>
                {index <= 2 ? (
                  <img
                    src={`/images/rank/medal_${index + 1}.png`}
                    alt=""
                    className="rank-icon"
                    width={48}
                    height={48}
                  />
                ) : (
                  <div
                    className="flex"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: 48,
                      width: 48,
                    }}
                  >
                    <div className="rank-sort">{index + 1}</div>
                  </div>
                )}
              </>
              <div className="relative">
                <MyImage
                  tag="v400"
                  src={item?.artwork?.artworkUrl || ''}
                  alt=""
                  className={`main-img main-img_${type}`}
                />
                {item?.artwork?.existItem && (
                  <span className="product-tag-item">
                    <CircleAndSquare /> <span className="ml-1">文创</span>
                  </span>
                )}
              </div>
            </div>
            <div className="middle">
              <div
                className="title"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div className="text line-one">{item?.artwork?.name}</div>
                <MyRare
                  className="-mt-0.5 ml-2"
                  rare={item?.artwork?.rareFlag as RareFlag}
                />
              </div>
              <div className={`info`}>
                <div
                  className="name"
                  onClick={e => {
                    e.stopPropagation()
                    router.push(`/user/${item.artwork?.nArtist?.uid}`)
                  }}
                >
                  {item.artwork?.nArtist?.nickname}
                  <span className="vip"></span>
                </div>
              </div>
            </div>
            <div className="right">
              {item?.artwork?.buy?.[0]?.price && (
                <div className="price">
                  ¥ {FenToYuan(item?.artwork?.buy?.[0]?.price)}
                </div>
              )}
            </div>
          </div>
        )
      )}
    </StyledItemContent>
  )
}
